// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PureDnD_wrapper__3FeG8"};